import { Autocomplete, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import React, { Component } from 'react'
import ApiRequestService from '../ApiRequestService';
import { NotificationManager } from 'react-notifications';
import "./style.css";
import SFTabs from './SFTabs';
import SFAssignmentDetail from './SFAssignmentDetail';
import SFTopicDetail from './SFTopicDetail';
import SFMySetDetail from './SFMySetDetail';


export default class PerfAnalytics extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedSemester: null,

      courses: [],
      selectedCourse: null,

      sections: [],
      selectedSection: null,

      students: [],
      selectedStudent: null,
      selectedStudentObj: null,

      tabs: [
        { id: 0, value: "By Assignments" },
        { id: 1, value: "By Topics" },
        { id: 2, value: "My Sets" },
      ],
      activeTabIndex: 0,
      count: 0,

      savedAssignmentsForAllStudents: {},
      savedTopicsForAllStudents: {},
    }
  }

  handleSemesterSelect = (event) => {
    let val = event.target.value;
    this.setState({
      selectedSemester: val,

      // reset
      courses: [],
      selectedCourse: null,

      sections: [],
      selectedSection: null,

      students: [],
      selectedStudent: null
    });
    this.getCourses(val);
  }

  handleUpdateCount = (count) => {
    this.setState({
      count: count,
    })
  }

  getCourses(semesterID) {
    ApiRequestService({
      method: "POST",
      url: "/getAllCoursesForSemester",
      data: {
        id: semesterID
      }
    }).then(res => {
      if (res && res.data && res.data.data) {
        let data = res.data.data;
        if (data && data.course_names) {
          this.setState({
            courses: data.course_names
          })
        }
      } else {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
        }
        this.setState({
          courses: []
        })
      }
    })
  }

  handleCourseSelect = (event) => {
    let val = event.target.value;
    this.setState({
      selectedCourse: val,

      // reset
      sections: [],
      selectedSection: null,

      students: [],
      selectedStudent: null
    });
    this.getSections(val, this.state.selectedSemester);
  }

  getSections(courseID, semesterID) {
    ApiRequestService({
      method: 'post',
      url: '/getAllSections',
      data: {
        course_id: courseID,
        semesterID: semesterID,
      }
    }).then(res => {

      if (res && res.data && res.data.data) {
        this.setState({
          sections: res.data.data.section_names,
        })
      } else {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
        }
        this.setState({
          sections: [],
        })
      }
    });
  }


  handleSectionSelect = (event) => {
    let val = event.target.value;
    this.setState({
      selectedSection: val,

      // reset
      students: [],
      selectedStudent: null
    });

    this.getStudents(this.state.selectedCourse, val);
  }

  getStudents = (courseID, sectionID) => {
    ApiRequestService({
      method: 'post',
      url: '/getAllStudentEnrollmentByID',
      data: {
        course_id: courseID,
        section_id: sectionID,
      }
    }).then(res => {
      if (res && res.data && res.data.data) {
        this.setState({
          students: res.data.data,
        })
      } else {
        if (res.data.message !== null && res.data.message !== '') {
          NotificationManager.error(res.data.message, 'ERROR', 3000);
        }
        this.setState({
          students: []
        });
      }
    });
  }

  handleStudentSelect = (event) => {
    let val = event.target.value;
    this.setState({
      selectedStudent: val,
      activeTabIndex: 0,
    })
  }

  onTabClick = (tabIndex) => {
    this.setState({
      activeTabIndex: tabIndex,
      activeQuizID: null,
      count: 0,
    })
  }

  render() {

    let savedKey = `${this.state.selectedCourse}_${this.state.selectedSection}`;

    return (
      <div>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <FormControl fullWidth>

              {/* Semester */}
              <Autocomplete
                id="semester-select-id"
                disablePortal
                options={
                  this.props.semesters?.map((semester) => {
                    let name = semester.name;
                    if (semester.isCurrent) {
                      name += " (Current)"
                    }
                    return {
                      label: name,
                      value: semester.id,
                    }
                  }) || []
                }
                value={
                  this.props.semesters
                    ? this.props.semesters
                      .map((semester) => {
                        let name = semester.name;
                        if (semester.isCurrent) {
                          name += " (Current)"
                        }
                        return {
                          label: name,
                          value: semester.id,
                        }
                      })
                      .find((opt) => opt.value === this.state.selectedSemester) || null
                    : null
                }
                onChange={(_, obj) => {
                  this.handleSemesterSelect({
                    target: { value: obj ? obj.value : null },
                  });
                }}
                renderInput={(params) => <TextField variant='standard' {...params} label="Semesters" />}
              />
            </FormControl>
          </Grid>


          {/* Course */}
          {this.state.selectedSemester ?
            <Grid item xs={3}>
              <FormControl fullWidth>
                <Autocomplete
                  id="course-select-id"
                  disablePortal
                  options={
                    this.state.courses?.map((course) => ({
                      label: course.course_name,
                      value: course.course_id,
                    })) || []
                  }
                  value={
                    this.state.courses
                      ? this.state.courses
                        .map((course) => ({
                          label: course.course_name,
                          value: course.course_id,
                        }))
                        .find((opt) => opt.value === this.state.selectedCourse) || null
                      : null
                  }
                  onChange={(_, obj) => {
                    this.handleCourseSelect({
                      target: { value: obj ? obj.value : null },
                    });
                  }}
                  renderInput={(params) => <TextField variant='standard' {...params} label="Courses" />}
                />

              </FormControl>
            </Grid>
            : null}


          {/* Section */}
          {this.state.selectedCourse ?
            <Grid item xs={3}>
              <FormControl fullWidth>
                <Autocomplete
                  id="section-select-id"
                  disablePortal
                  options={
                    this.state.sections?.map((section) => ({
                      label: section.section_name,
                      value: section.section_id,
                    })) || []
                  }
                  value={
                    this.state.sections
                      ? this.state.sections
                        .map((section) => ({
                          label: section.section_name,
                          value: section.section_id,
                        }))
                        .find((opt) => opt.value === this.state.selectedSection) || null
                      : null
                  }
                  onChange={(_, obj) => {
                    this.handleSectionSelect({
                      target: { value: obj ? obj.value : null },
                    });
                  }}
                  renderInput={(params) => <TextField variant='standard' {...params} label="Sections" />}
                />

              </FormControl>
            </Grid>
            : null}

          {/* Username */}
          {this.state.selectedSection ?
            <Grid item xs={2}>
              <FormControl fullWidth>
                <Autocomplete
                  id="student-select-id"
                  disablePortal
                  options={
                    [
                      {
                        label: "Select All",
                        value: "all",
                        fullName: "Select All",
                      },
                      ...this.state.students?.map((student) => ({
                        label: student.userid,
                        value: student.userid,
                        fullName: `${student.first_name} ${student.last_name}`,
                      })) || []
                    ]
                  }
                  value={
                    this.state.selectedStudent ?
                      {
                        label: this.state.selectedStudent === "all" ? "Select All" : this.state.selectedStudent,
                        value: this.state.selectedStudent,
                      } :
                      null
                  }
                  onChange={(_, obj) => {
                    this.setState({selectedStudentFullName: obj ? obj.fullName : ""})
                    this.handleStudentSelect({
                      target: { value: obj ? obj.value : null },
                    });
                  }}
                  renderInput={(params) => <TextField variant='standard' {...params} label="Student Username" />}
                />

              </FormControl>
            </Grid>
            : null}

          {/* Full Name */}
          {this.state.selectedSection ?
            <Grid item xs={2}>
              <FormControl fullWidth>
                <Autocomplete
                  id="student-name-select-id"
                  disablePortal
                  options={
                    [
                      {
                        label: "Select All",
                        value: "all",
                        fullName: "Select All",
                      },
                      ...this.state.students?.map((student) => ({
                        label: `${student.first_name} ${student.last_name}`,
                        value: student.userid,
                        fullName: `${student.first_name} ${student.last_name}`,
                      })) || []
                    ]
                  }
                  value={
                    this.state.selectedStudentFullName ?
                      {
                        label: this.state.selectedStudentFullName,
                        value: this.state.selectedStudent,
                      } :
                      null
                  }
                  onChange={(_, obj) => {
                    this.setState({selectedStudentFullName: obj.fullName})
                    this.handleStudentSelect({
                      target: { value: obj ? obj.value : null },
                    });
                  }}
                  renderInput={(params) => <TextField variant='standard' {...params} label="Student Full Name" />}
                />

              </FormControl>
            </Grid>
            : null}

        </Grid>

        {this.state.selectedStudent ?
          <div style={{ height: "100%" }}>
            <div style={{ marginTop: "8px" }}>
              {/* Tabs */}
              <div className='ml-2' style={{ height: '50px' }}>
                <SFTabs
                  tabs={this.state.tabs}
                  activeTabIndex={this.state.activeTabIndex}
                  onTabClick={this.onTabClick}
                  selectedStudentUserName={this.state.selectedStudent}
                  count={this.state.count}
                />
              </div>
            </div>

            {this.state.activeTabIndex === 0 ?
              <SFAssignmentDetail
                handleAddCategory={() => { }}
                handleRemoveCategory={() => { }}
                selectedCategories={[]}
                selectedCourse={{
                  course_id: this.state.selectedCourse,
                  section_id: this.state.selectedSection,
                }}
                selectedInstructorSectionID={this.state.selectedSection}
                handleUpdateCount={this.handleUpdateCount}
                onAddActivityLog={() => { }}
                handleRoute={() => { }}
                selectedStudentUserName={this.state.selectedStudent}
                isInstructor={true}
                savedAssignmentsForAllStudents={this.state.savedAssignmentsForAllStudents[savedKey]}
                updateSavedAssignmentsForAllStudents={(mkey, dataArr) => {
                  let newData = this.state.savedAssignmentsForAllStudents;
                  newData[mkey] = dataArr;
                  this.setState({
                    savedAssignmentsForAllStudents: newData
                  })
                }}
              />
              : null}
            {this.state.activeTabIndex === 1 ?
              <SFTopicDetail
                handleAddCategory={() => { }}
                handleRemoveCategory={() => { }}
                selectedCategories={[]}
                selectedInstructorSectionID={this.state.selectedSection}
                selectedCourse={{
                  course_id: this.state.selectedCourse,
                  section_id: this.state.selectedSection,
                }}
                handleUpdateCount={this.handleUpdateCount}
                onAddActivityLog={() => { }}
                handleRoute={() => { }}
                selectedStudentUserName={this.state.selectedStudent}
                isInstructor={true}
                savedTopicsForAllStudents={this.state.savedTopicsForAllStudents[savedKey]}
                updateSavedTopicsForAllStudents={(mkey, dataArr) => {
                  let newData = this.state.savedTopicsForAllStudents;
                  newData[mkey] = dataArr;
                  this.setState({
                    savedTopicsForAllStudents: newData
                  })
                }}
              />
              : null}
            {this.state.activeTabIndex === 2 ?
              <SFMySetDetail
                handleAddCategory={() => { }}
                handleRemoveCategory={() => { }}
                selectedCategories={[]}
                selectedCourse={{
                  course_id: this.state.selectedCourse,
                  section_id: this.state.selectedSection,
                }}
                handleUpdateCount={this.handleUpdateCount}
                onAddActivityLog={() => { }}
                handleRoute={() => { }}
                activeQuizID={null}
                selectedStudentUserName={this.state.selectedStudent}
                isInstructor={true}
              />
              : null}
          </div>
          : null}
      </div>
    )
  }
}
